import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";

import {
  Button,
  Alert,
  Form,
  Col,
  FormGroup,
  Label,
  Input,
  Container,
  Card,
  CardBody
} from "reactstrap";

class ForgotPassword extends Component {
  static displayName = "Forgot Password Page";

  constructor(props) {
    super(props);

    this.state = {
      username: "",
      error: "",
      success: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(name, value) {
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { username } = this.state;
    let self = this;
    axios
      .post("/auth/forgot-password", { username: username })
      .then(res => {
        self.setState({
          success: true,
          error: ""
        });
      })
      .catch(function(error) {
        self.setState({
          error: error.response.data.message
        });
      });
  }

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/" />;
    }

    return (
      <section className="login-container">
        <Container>
          <Col sm={10} md={6} lg={4} xl={4}>
            <Card>
              {/* <CardBody><img src={Logo} width={180} /></CardBody> */}
              <CardBody>
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Label htmlFor="email">E-Mail Address</Label>
                    <Input
                      placeholder="Email Address"
                      type="email"
                      name="username"
                      autoFocus
                      onChange={e =>
                        this.handleChange(e.target.name, e.target.value)
                      }
                    />
                  </FormGroup>

                  <FormGroup>
                    <Button color="primary" type="submit" size="lg" block>
                      Reset Password
                    </Button>
                  </FormGroup>
                  {this.state.error ? (
                    <FormGroup>
                      <Alert color="danger">{this.state.error}</Alert>
                    </FormGroup>
                  ) : (
                    ""
                  )}
                  {this.state.success ? (
                    <FormGroup>
                      <Alert color="success">
                        Please check your email for instructions
                      </Alert>
                    </FormGroup>
                  ) : (
                    ""
                  )}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Container>
      </section>
    );
  }
}

function mapStateToProps(store) {
  return {
    isAuthenticated: store.auth.isAuthenticated
  };
}

export default connect(mapStateToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/system/containers/ForgotPassword/ForgotPassword.jsx